import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

import { typographyVariants } from './typography-variants';

const articleVariant = defineStyle(() => {
  return {
    container: {
      borderRadius: 'none',
      bg: 'tag-bg-light',
      color: 'text-dark.500',
    },
  };
});

const articleFeaturedVariant = defineStyle(() => {
  return {
    container: {
      ...articleVariant().container,
      background: 'red.100',
      borderColor: 'red.100',
    },
  };
});

const casestudyVariant = defineStyle(() => {
  return {
    container: {
      backgroundColor: 'tag-bg',
      borderRadius: '1px',
      px: 2,
      py: '2px',
      color: 'text.500',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 'fit-content',
    },
  };
});

export const tagTheme = defineStyleConfig({
  variants: {
    article: articleVariant,
    articleFeatured: articleFeaturedVariant,
    casestudy: casestudyVariant,
  },
  sizes: {
    xl: {
      container: {
        ...typographyVariants['text-sm/lineHeight-5/font-medium'],
        px: 2,
        h: 6,
      },
    },
    md: {
      container: {
        ...typographyVariants['text-xs/lineHeight-4/font-medium/letterSpacing-wide'],
      },
    },
  },
});
